/** 确认对话框 (基于通用 Dialog: Esc / 点遮罩 = 取消) */
import { AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/Button";
import { Dialog } from "@/components/ui/Dialog";

interface Props {
  open: boolean;
  title: string;
  message?: string;
  confirmText?: string;
  destructive?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export function ConfirmDialog({
  open, title, message, confirmText = "确认", destructive, onConfirm, onCancel,
}: Props) {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      size="sm"
      hideClose
      aria-label={title}
      footer={
        <>
          <Button variant="outline" onClick={onCancel}>取消</Button>
          <Button variant={destructive ? "danger" : "primary"} onClick={onConfirm} data-autofocus>
            {confirmText}
          </Button>
        </>
      }
    >
      <div className="flex gap-3">
        {destructive && (
          <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-danger-soft">
            <AlertTriangle aria-hidden className="h-4 w-4 text-danger" />
          </div>
        )}
        <div className="min-w-0 space-y-1 pt-0.5">
          <h2 className="text-section text-foreground">{title}</h2>
          {message && <p className="text-sm text-muted-foreground">{message}</p>}
        </div>
      </div>
    </Dialog>
  );
}
